import { clampSurfaceLevel, type SurfaceLevel } from "~/lib/surface-level";

export const SURFACE_BG: Record<SurfaceLevel, string> = {
  1: "bg-surface-1",
  2: "bg-surface-2",
  3: "bg-surface-3",
  4: "bg-surface-4",
  5: "bg-surface-5",
  6: "bg-surface-6",
  7: "bg-surface-7",
  8: "bg-surface-8",
};

export const SURFACE_SHADOW: Record<SurfaceLevel, string> = {
  1: "shadow-surface-1",
  2: "shadow-surface-2",
  3: "shadow-surface-3",
  4: "shadow-surface-4",
  5: "shadow-surface-5",
  6: "shadow-surface-6",
  7: "shadow-surface-7",
  8: "shadow-surface-8",
};

export function surfaceClasses(
  backgroundLevel: number,
  shadowLevel: number = backgroundLevel,
): string {
  const background = clampSurfaceLevel(backgroundLevel);
  const shadow = clampSurfaceLevel(shadowLevel);

  return `${SURFACE_BG[background]} ${SURFACE_SHADOW[shadow]}`;
}
